<template>
  <div v-if="taxRate" class="ta-auction-bp-tax-rate">
    <label v-if="label === true" class="ta-auction-bp-tax-rate-label">{{ $t('VAT on Buyer\'s Premium') }} &nbsp;</label>
    <label v-else-if="label"  class="ta-auction-bp-tax-rate-label">{{ label }}</label>
    <span class="ta-auction-bp-tax-rate-value">{{ taxRate }}%</span>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "BuyersPremiumTaxRate",
  props: {
    label: {
      type: [Boolean, String],
      default: true
    },
    auction: {
      required: false,
      type: [Object, Boolean],
      default: () => false
    },
  },
  computed: {
    ...mapState({auctionVuex: state => state.auctionObject.data}),
    auctionObj() {
      return this.auction || this.auctionVuex
    },
    taxRate() {
      let rate = parseFloat(this.auctionObj.bp_tax_rate)
      if (parseInt(this.auctionObj.bp_tax_rate) < rate) {
        return rate.toFixed(1)
      }
      return rate;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
